// src/components/monthly/ApplyFormComplete.tsx
import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

export const ApplyFormComplete: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const langSegment = location.pathname.split('/')[1];
  const useEnglish = langSegment === 'en';

  const handleHotelTopClick = () => {
    // 英語の場合は /en/hotel、そうでなければ /hotel
    navigate(useEnglish ? '/en/hotel' : '/hotel');
  };

  const handleMonthlyTopClick = () => {
    // 英語の場合は /en/monthly、そうでなければ /monthly
    navigate(useEnglish ? '/en/monthly' : '/ja/monthly');
  };

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center bg-[#F9F6E7] p-4 text-center">
      {/* 左上に浮かせるリンク */}
      <div className="absolute top-0 left-0 p-4">
        <Link to={`/${langSegment}/monthly`} className="block text-black">
          The (Apartment)
          <div>Hotel</div>
        </Link>
      </div>

      <h1 className="text-2xl font-light mb-4">
        {useEnglish
          ? 'Your application has been submitted successfully.'
          : '申込情報の送信が完了しました'}
      </h1>
      <p className="text-sm text-red-600 mb-8 max-w-[600px]">
        {useEnglish
          ? 'To complete the application process, please register your credit card details via the link provided in the email sent by iSync Rent Co., Ltd.'
          : '※お申込手続き完了のためには、この後、株式会社アイシンクレントよりお送りするメールに記載されているリンクから、クレジットカード情報のご登録をお願いいたします。'}
      </p>
      <div className="flex space-x-4">
        <button
          onClick={handleMonthlyTopClick}
          className="border border-black px-4 py-2 text-sm bg-black text-white"
        >
          {useEnglish ? 'Return to Home Page' : 'トップページに戻る'}
        </button>
      </div>
    </div>
  );
};

export default ApplyFormComplete;
